// Auto-generated from rail.json
export default {
  "tagName": "ui-rail"
};
